// ProvVakt → the rest of the page: what /api/prov-elev/aktivt just answered. ProvVakt is the
// only poller of that route; consumers listen instead of polling it themselves (prestandapass
// 2026-10-27 — Nav used to run its own 30 s poll of the same route):
//  - ProvElevClient: an open prov page whose own pass is no longer named checks its pass once
//    and closes (Erik 2026-10-27: the teacher's "Avsluta för alla" ends the prov at once).
//  - useProvNavMobilparning: whether the running pass allows the pairing button.
// Stateless on purpose — every answer is announced, so nothing is lost when ProvVakt remounts.
export const PROV_LAGE_EVENT = "vektr:prov-lage";

export interface ProvLageDetalj {
  /** The pass the student is writing or has open, or null for none. */
  passId: string | null;
  /** The student has started that pass. */
  aktivt: boolean;
  /** The running pass allows a paired phone or tablet (the shared QR button). */
  mobilTillaten: boolean;
  /** The student's end time in the running pass (ISO), or null for none. The teacher can move
   *  it for everyone mid-prov (Öppettid / "Förläng för alla"); the prov page follows it. */
  slutTid?: string | null;
  /** Vektr-lås is on for the running pass (Provinstallningar.inlast) — the prov page watches
   *  that its tab stays active. The teacher can switch it mid-prov. */
  inlast?: boolean;
  /** The running pass is Vektr-locked for the student right now; false after the teacher
   *  unlocked it in Utföra. */
  vektrLast?: boolean;
}

/** The last answer, for a listener that mounts between two polls. */
let senaste: ProvLageDetalj | null = null;

export function signaleraProvLage(detalj: ProvLageDetalj): void {
  senaste = detalj;
  window.dispatchEvent(new CustomEvent<ProvLageDetalj>(PROV_LAGE_EVENT, { detail: detalj }));
}

export function senasteProvLage(): ProvLageDetalj | null {
  return senaste;
}
